import * as React from 'react'

export const useOpenAllFaqs = (faqIdString = 'FAQ', listLength = 0) => {
  const [expandedCollapsibles, setExpandedCollapsibles] = React.useState<Record<string, boolean>>({})

  React.useEffect(() => {
    const obj: Record<string, boolean> = {}
    for (let i = 1; i <= listLength; i++) {
      obj[`${faqIdString} #${i}`] = true
    }
    setExpandedCollapsibles(obj)
  }, [listLength, faqIdString])

  return expandedCollapsibles
}
